import { useSelector } from "react-redux"

import { selectCurrentOrgId } from "features/store/orgSlice"
import AlertsContent from "widgets/alerts/AlertsContent"
import { AlertSettingDrawerProvider } from "widgets/alerts/settings/AlertSettingDrawer"

const AlertsTab = () => {
  const orgId = useSelector(selectCurrentOrgId)
  return (
    <AlertSettingDrawerProvider>
      <AlertsContent key={orgId} />
    </AlertSettingDrawerProvider>
  )
}

export default AlertsTab
